module.exports = __webpack_public_path__ + "static/img/yiti_07.fe1a872a.jpg";